(() => {
  angular
    .module('gm.common.directives')
    .directive('btgImagePreview', btgImagePreviewDirective);

  function btgImagePreviewDirective() {
    'ngInject';

    return {
      restrict: 'E',
      scope: {
        image: '=',
        progress: '='
      },
      templateUrl: 'modules/common/directives/image-preview/image-preview.html'
    };
  }
})();
